import { Box, type BoxProps } from '@mui/material';
import { forwardRef } from 'react';

export interface SpanProps extends Omit<BoxProps, 'component'> {}

export const Span = forwardRef((props: SpanProps, ref) => {
  return <Box component="span" {...props} ref={ref} />;
});

Span.displayName = 'Span';
